// @ts-nocheck
/* eslint-disable no-case-declarations */
import { INITIAL_ITEMS } from '../RegisterForm/CustomFormBuilder/config/constant';
import {
  addColumn,
  addRow,
  deleteColumn,
  duplicateColumn,
  duplicateRow,
  editTableRow,
  updateColumnType,
  updateTableRow,
  updateTableColumn,
  updateColumnHeader,
  updateColumn,
  updateChoice,
  updateTable,
  deleteRow,
  updateAnswer,
  addColumnFromDrawer,
  reorderTableRow,
  resizeTableColumn,
  editTableColumn,
  editTableHeaders,
  updateTableHeaders,
  updatePreviewColumn,
  resetForm,
  setTableIsRequired,
  updateColumnRequiredField,
} from './reducerHelpers';

const initialFormFields = INITIAL_ITEMS[0].elements;

const initialState = {
  initialItem: INITIAL_ITEMS,
  items: initialFormFields,
  isRequired: false,
  isConditional: false,
  section: '',
  title: '',
  description: '',
  formFields: [],
  formJson: '',
  activeTableField: {
    isEditingRow: false,
    tableId: null,
    isTableRequired: false,
    contentIndex: null,
    contents: [],
    headers: [],
    requiredColumnIndexes: [],
  },
  version: '1.0.0',
  label: '',
  instruction: '',
  attachments: [],
  answer: '',
  selectedLinkListLabel: '',
  employeeRole: [],
  employeeData: [],
  userRole: [],
  userData: [],
  equipmentType: [],
  equipmentData: [],
  projectData: [],
  currentLocation: null,
  isStatusOnSubmission: 3,
  isCollectGeolocation: false,
  isEditResponse: false,
  // TimeSheet Settings
  isProjectTimesheetRequired: false,
  isProjectClockInCompulsory: false,
  isEmployeeTimesheetRequired: false,
  isEmployeeClockInCompulsory: false,
  isEquipmentOneResponsePerDay: false,
  isEquipmentShowPastResponses: false,
  isEquipmentClockInCompulsory: false,
  aiDescription: '',
};

const actionTypes = {
  SET_ITEMS: 'SET_ITEMS',
  SET_IS_REQUIRED: 'SET_IS_REQUIRED',
  SET_IS_CONDITIONAL: 'SET_IS_CONDITIONAL',
  SET_TITLE: 'SET_TITLE',
  SET_DESCRIPTION: 'SET_DESCRIPTION',
  SET_FORM_FIELDS: 'SET_FORM_FIELDS',
  SET_FORM_JSON: 'SET_FORM_JSON',
  SET_VERSION: 'SET_VERSION',
  SET_LABEL: 'SET_LABEL',
  SET_INSTRUCTION: 'SET_INSTRUCTION',
  SET_ATTACHMENTS: 'SET_ATTACHMENTS',
  SET_ANSWER: 'SET_ANSWER',
  SET_EMPLOYEE_ROLE: 'SET_EMPLOYEE_ROLE',
  SET_EMPLOYEE_DATA: 'SET_EMPLOYEE_DATA',
  SET_USER_ROLE: 'SET_USER_ROLE',
  SET_USER_DATA: 'SET_USER_DATA',
  SET_EQUIPMENT_TYPE: 'SET_EQUIPMENT_TYPE',
  SET_EQUIPMENT_DATA: 'SET_EQUIPMENT_DATA',
  SET_PROJECT_DATA: 'SET_PROJECT_DATA',
  SET_CURRENT_LOCATION: 'SET_CURRENT_LOCATION',
  SET_PROJECT_TIMESHEET_REQUIRED: 'SET_PROJECT_TIMESHEET_REQUIRED',
  SET_PROJECT_CLOCK_IN_COMPULSORY: 'SET_PROJECT_CLOCK_IN_COMPULSORY',
  SET_EMPLOYEE_TIMESHEET_REQUIRED: 'SET_EMPLOYEE_TIMESHEET_REQUIRED',
  SET_EMPLOYEE_CLOCK_IN_COMPULSORY: 'SET_EMPLOYEE_CLOCK_IN_COMPULSORY',
  SET_EQUIPMENT_ONE_RESPONSE_PER_DAY: 'SET_EQUIPMENT_ONE_RESPONSE_PER_DAY',
  SET_EQUIPMENT_SHOW_PAST_RESPONSES: 'SET_EQUIPMENT_SHOW_PAST_RESPONSES',
  SET_EQUIPMENT_CLOCK_IN_COMPULSORY: 'SET_EQUIPMENT_CLOCK_IN_COMPULSORY',
  SET_IS_STATUS_ON_SUBMISSION: 'SET_IS_STATUS_ON_SUBMISSION',
  SET_IS_COLLECT_GEOLOCATION: 'SET_IS_COLLECT_GEOLOCATION',
  SET_IS_EDIT_RESPONSE: 'SET_IS_EDIT_RESPONSE',
  SET_SECTION: 'SET_SECTION',
  SET_SELECTED_LINK_LIST_LABEL: 'SET_SELECTED_LINK_LIST_LABEL',

  RESET_FORM: 'RESET_FORM',
  UPDATE_TABLE: 'UPDATE_TABLE',
  ADD_COLUMN: 'ADD_COLUMN',
  ADD_COLUMN_FROM_DRAWER: 'ADD_COLUMN_FROM_DRAWER',
  ADD_ROW: 'ADD_ROW',
  DELETE_ROW: 'DELETE_ROW',
  DELETE_COLUMN: 'DELETE_COLUMN',
  DUPLICATE_COLUMN: 'DUPLICATE_COLUMN',
  EDIT_TABLE_ROW: 'EDIT_TABLE_ROW',
  EDIT_TABLE_COLUMN: 'EDIT_TABLE_COLUMN',
  EDIT_TABLE_HEADERS: 'EDIT_TABLE_HEADERS',
  UPDATE_COLUMN_TYPE: 'UPDATE_COLUMN_TYPE',
  UPDATE_TABLE_ROW: 'UPDATE_TABLE_ROW',
  UPDATE_TABLE_COLUMN: 'UPDATE_TABLE_COLUMN',
  UPDATE_TABLE_HEADERS: 'UPDATE_TABLE_HEADERS',
  UPDATE_COLUMN_HEADER: 'UPDATE_COLUMN_HEADER',
  UPDATE_COLUMN: 'UPDATE_COLUMN',
  UPDATE_CHOICE: 'UPDATE_CHOICE',
  UPDATE_ANSWER: 'UPDATE_ANSWER',
  UPDATE_PREVIEW_COLUMN: 'UPDATE_PREVIEW_COLUMN',
  REORDER_TABLE_ROW: 'REORDER_TABLE_ROW',
  RESIZE_TABLE_COLUMN: 'RESIZE_TABLE_COLUMN',
  SET_TABLE_IS_REQUIRED: 'SET_TABLE_IS_REQUIRED',
  SET_ASSIGN_ALL_PROJECTS: 'SET_ASSIGN_ALL_PROJECTS',
  SET_ASSIGN_ALL_USERS: 'SET_ASSIGN_ALL_USERS',
  SET_ASSIGN_ALL_EMPLOYEES: 'SET_ASSIGN_ALL_EMPLOYEES',
  UPDATE_COLUMN_REQUIRED_FIELD: 'UPDATE_COLUMN_REQUIRED_FIELD',
  SET_AI_DESCRIPTION: 'SET_AI_DESCRIPTION',
  SET_SUBMISSION_FREQUENCY: 'SET_SUBMISSION_FREQUENCY',
  SET_WEEK_START: 'SET_WEEK_START',
};

const reducer = (state, action) => {
  const { id } = action.payload || {};
  const fieldData = state?.formFields?.find((field) => field?.id === id);
  switch (action.type) {
    case actionTypes.SET_ITEMS:
      return { ...state, items: action.payload };
    case actionTypes.SET_TITLE:
      return { ...state, title: action.payload };
    case actionTypes.SET_DESCRIPTION:
      return { ...state, description: action.payload };
    case actionTypes.SET_FORM_FIELDS:
      const formFields = action.payload;
      return { ...state, formFields };
    case actionTypes.SET_FORM_JSON:
      return { ...state, formJson: action.payload };
    case actionTypes.SET_IS_REQUIRED:
      const { isRequired } = action.payload;
      if (fieldData) {
        return {
          ...state,
          formFields: state.formFields.map((field) =>
            field.id === id ? { ...field, isRequired } : field,
          ),
        };
      }
      return state;
    case actionTypes.SET_IS_CONDITIONAL:
      const { isConditional } = action.payload;

      if (fieldData) {
        return {
          ...state,
          formFields: state.formFields.map((field) =>
            field.id === id ? { ...field, isConditional } : field,
          ),
        };
      }
      return state;
    case actionTypes.SET_VERSION:
      return { ...state, version: action.payload };
    case actionTypes.SET_LABEL:
      const { label } = action.payload;
      if (fieldData) {
        return {
          ...state,
          formFields: state.formFields.map((field) =>
            field.id === id ? { ...field, label } : field,
          ),
        };
      }
      return state;

    case actionTypes.SET_INSTRUCTION:
      const { instruction } = action.payload;

      if (fieldData) {
        return {
          ...state,
          formFields: state.formFields.map((field) =>
            field.id === id ? { ...field, instruction } : field,
          ),
        };
      }
      return state;

    case actionTypes.SET_SECTION:
      const { section } = action.payload;

      if (fieldData) {
        return {
          ...state,
          formFields: state.formFields.map((field) =>
            field.id === id ? { ...field, section } : field,
          ),
        };
      }
      return state;
    case actionTypes.SET_ATTACHMENTS:
      const { attachments } = action.payload;

      if (fieldData) {
        return {
          ...state,
          formFields: state.formFields.map((field) =>
            field.id === id ? { ...field, attachments } : field,
          ),
        };
      }
      return state;

    case actionTypes.SET_ANSWER:
      const { answer } = action.payload;
      const fieldAnswerData = state.formFields.find((field) => field.id === id);
      if (fieldAnswerData) {
        return {
          ...state,
          formFields: state.formFields.map((field) =>
            field.id === id ? { ...field, answer } : field,
          ),
        };
      }
      return state;
    case actionTypes.SET_SELECTED_LINK_LIST_LABEL:
      const { selectedLinkListLabel } = action.payload;

      if (fieldData) {
        return {
          ...state,
          formFields: state.formFields.map((field) =>
            field.id === id ? { ...field, selectedLinkListLabel } : field,
          ),
        };
      }
      return state;
    case actionTypes.SET_EMPLOYEE_ROLE:
      const employeeRole = action.payload;
      return { ...state, employeeRole };
    case actionTypes.SET_EMPLOYEE_DATA:
      const employeeData = action.payload;
      return { ...state, employeeData };
    default:
      return state;
    case actionTypes.SET_USER_ROLE:
      const userRole = action.payload;
      return { ...state, userRole };
    case actionTypes.SET_USER_DATA:
      const userData = action.payload;
      return { ...state, userData };
    case actionTypes.SET_EQUIPMENT_TYPE:
      const equipmentType = action.payload;
      return { ...state, equipmentType };
    case actionTypes.SET_EQUIPMENT_DATA:
      const equipmentData = action.payload;
      return { ...state, equipmentData };
    case actionTypes.SET_PROJECT_DATA:
      const projectData = action.payload;
      return { ...state, projectData };
    case actionTypes.SET_CURRENT_LOCATION:
      const currentLocation = action.payload;
      return { ...state, currentLocation };

    case actionTypes.SET_PROJECT_TIMESHEET_REQUIRED:
      const isProjectTimesheetRequired = action.payload;
      return { ...state, isProjectTimesheetRequired };
    case actionTypes.SET_PROJECT_CLOCK_IN_COMPULSORY:
      const isProjectClockInCompulsory = action.payload;
      return { ...state, isProjectClockInCompulsory };

    case actionTypes.SET_EMPLOYEE_TIMESHEET_REQUIRED:
      const isEmployeeTimesheetRequired = action.payload;
      return { ...state, isEmployeeTimesheetRequired };
    case actionTypes.SET_EMPLOYEE_CLOCK_IN_COMPULSORY:
      const isEmployeeClockInCompulsory = action.payload;
      return { ...state, isEmployeeClockInCompulsory };
    case actionTypes.SET_EQUIPMENT_ONE_RESPONSE_PER_DAY:
      const isEquipmentOneResponsePerDay = action.payload;
      return { ...state, isEquipmentOneResponsePerDay };
    case actionTypes.SET_EQUIPMENT_SHOW_PAST_RESPONSES:
      const isEquipmentShowPastResponses = action.payload;
      return { ...state, isEquipmentShowPastResponses };
    case actionTypes.SET_EQUIPMENT_CLOCK_IN_COMPULSORY:
      const isEquipmentClockInCompulsory = action.payload;
      return { ...state, isEquipmentClockInCompulsory };

    case actionTypes.SET_IS_STATUS_ON_SUBMISSION:
      const isStatusOnSubmission = action.payload;
      return { ...state, isStatusOnSubmission };
    case actionTypes.SET_IS_COLLECT_GEOLOCATION:
      const isCollectGeolocation = action.payload;
      return { ...state, isCollectGeolocation };
    case actionTypes.SET_IS_EDIT_RESPONSE:
      const isEditResponse = action.payload;
      return { ...state, isEditResponse };

    case actionTypes.RESET_FORM:
      return resetForm(state);
    case actionTypes.UPDATE_TABLE:
      return updateTable(state, action);
    case actionTypes.ADD_COLUMN:
      return addColumn(state, action);
    case actionTypes.ADD_ROW:
      return addRow(state, action);
    case actionTypes.ADD_COLUMN_FROM_DRAWER:
      return addColumnFromDrawer(state, action);
    case actionTypes.DELETE_ROW:
      return deleteRow(state, action);
    case actionTypes.DELETE_COLUMN:
      return deleteColumn(state, action);
    case actionTypes.DUPLICATE_COLUMN:
      return duplicateColumn(state, action);
    case actionTypes.DUPLICATE_ROW:
      return duplicateRow(state, action);
    case actionTypes.EDIT_TABLE_ROW:
      return editTableRow(state, action);
    case actionTypes.EDIT_TABLE_COLUMN:
      return editTableColumn(state, action);
    case actionTypes.EDIT_TABLE_HEADERS:
      return editTableHeaders(state, action);
    case actionTypes.UPDATE_COLUMN_TYPE:
      return updateColumnType(state, action);
    case actionTypes.UPDATE_TABLE_ROW:
      return updateTableRow(state);
    case actionTypes.UPDATE_TABLE_COLUMN:
      return updateTableColumn(state);
    case actionTypes.UPDATE_TABLE_HEADERS:
      return updateTableHeaders(state);
    case actionTypes.UPDATE_COLUMN_HEADER:
      return updateColumnHeader(state, action);
    case actionTypes.UPDATE_COLUMN:
      return updateColumn(state, action);
    case actionTypes.UPDATE_COLUMN_REQUIRED_FIELD:
      return updateColumnRequiredField(state, action);
    case actionTypes.UPDATE_CHOICE:
      return updateChoice(state, action);
    case actionTypes.UPDATE_ANSWER:
      return updateAnswer(state, action);
    case actionTypes.UPDATE_PREVIEW_COLUMN:
      return updatePreviewColumn(state, action);
    case actionTypes.REORDER_TABLE_ROW:
      return reorderTableRow(state, action);
    case actionTypes.RESIZE_TABLE_COLUMN:
      return resizeTableColumn(state, action);
    case actionTypes.SET_TABLE_IS_REQUIRED:
      return setTableIsRequired(state, action);
    case actionTypes.SET_ASSIGN_ALL_PROJECTS:
      const assignAllProjects = action.payload;
      return { ...state, assignAllProjects };
    case actionTypes.SET_ASSIGN_ALL_USERS:
      const assignAllUsers = action.payload;
      return { ...state, assignAllUsers };
    case actionTypes.SET_ASSIGN_ALL_EMPLOYEES:
      const assignAllEmployees = action.payload;
      return { ...state, assignAllEmployees };
    case actionTypes.SET_AI_DESCRIPTION:
      return { ...state, aiDescription: action.payload };
    case actionTypes.SET_SUBMISSION_FREQUENCY:
      const submissionFrequency = action.payload;
      return { ...state, submissionFrequency };
    case actionTypes.SET_WEEK_START:
      const weekStart = action.payload;
      return { ...state, weekStart };
  }
};

export { initialState, actionTypes, reducer };
